// Поверхность, на которой лежит блок (D-27, §2.4).
// Source: docs/specs/design-revision/d-design-system.md §2.4.
//
// Сейчас карточка в приложении — это то `bg-white` с рамкой, то `bg-muted/40`
// без рамки, то `bg-background` поверх серой секции, и скругления
// `rounded-surface` и `rounded-surface` вперемешку. Серая заливка перестаёт быть
// способом выделить блок: для этого есть рамка.

import type { ElementType, ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function Surface({
  as: Tag = 'div',
  className,
  children,
  ...rest
}: {
  as?: ElementType;
  className?: string;
  children?: ReactNode;
} & Record<string, unknown>) {
  return (
    <Tag
      className={cn('rounded-surface border border-border bg-surface', className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}
